const en = {
  evirPx_settings: 'Settings',
  evirPx_settings_description: 'View the',
  evirPx_missing_inspection_rules_report: 'Missing Inspection Rules report',
  evirPx_settings_create_edit_rules: 'to create and edit new rules for your assets.',
  evirPx_settings_saved: 'Settings saved successfully',
  evirPx_settings_save_failed: 'Save failed: No response data',
  evirPx_settings_save_error: 'The settings could not be saved. Please try again.',
  evirPx_settings_user_not_available: 'User information not available',
  evirPx_default_asset_type: 'Default asset type for EVIR Mobile',
  evirPx_default_asset_type_desc: 'Please choose which asset type should be the default for all future inspections.',
  evirPx_inspection_image_retention: 'Inspection and image retention',
  evirPx_retention_desc: 'Amount of time inspections and images will be kept on file.',
  evirPx_retain_for_number_of_years: 'Retain for number of years',
  evirPx_save: 'Save Settings',
  evirPx_undo: 'Undo',
  evirPx_saving: 'Saving...',
  evirPx_retention_1_year: '1 Year',
  evirPx_retention_2_years: '2 Years',
  evirPx_retention_3_years: '3 Years',
  evirPx_retention_5_years: '5 Years',
};

export default en;
